<template>
  <div class="plugins">
    <bimContainer>
      <bimCol xxl=10 xl=11 sm=12 class="mx-auto">
        <div class="plugins__header">
          <bim-text class="plugins__title" type="h1" bold>Плагины для Ревит и Архикад</bim-text>
          <bim-text class="plugins__desc mx-auto pt-7 pb-6" type="main">В помощь проектировщикам на этой странице мы собираем библиотеку актуальных и полезных плагинов для Revit и Archicad.</bim-text>
          <bim-text class="plugins__info mx-auto pb-9" type="medium">Если вы представитель производителя, то будем рады видеть ваши плагины для САПР на этой странице. Нет корпоративного плагина? Мы <a href="/dev/" target="_blank" class="plugins__link">готовы его разработать</a>.</bim-text>
          <a class="d-block mb-11" href="/dev/" target="_blank">
            <bimButton
              label="Узнать больше"
              class="plugins__button"
            />
          </a>
        </div>

        <SearchPlugins />
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimCol from "@bimlib/components/bimCol"
import bimButton from "@bimlib/components/bimButton";
import bimContainer from "@bimlib/components/bimContainer";

import SearchPlugins from "./components/SearchPlugins";
export default {
  name: "",
  components: {
    bimCol,
    bimButton,
    bimContainer,
    SearchPlugins,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.plugins {
  padding: 52px 0 64px;
  background-color: #fafafa;

  .plugins__header {
    text-align: center;
  }

  .plugins__title {
    ::v-deep .text__inner {
      font-size: 42px;
      line-height: 1.14;
    }
  }

  .plugins__link {
    border-bottom: 1px dashed $primary-color;
  }

  .plugins__desc {
    max-width: 920px;
  }

  .plugins__info {
    max-width: 640px;
  }

  .plugins__button {
    padding: 18px 28px;
    height: auto;
    font-size: 14px;
    line-height: 1.36;
  }
}
</style>
